import { PURCHASE_ORDERS_TABLE_COLUMN_ORDER, PURCHASE_ORDERS_TABLE_VISIBLE_COLUMNS } from "Shared/services/localstorage.service"
import { PurchaseOrderColumns } from "Features/pages/purchaseOrders/columns/PurchaseOrderColumns"
import { useTable, UseTablePropsBase } from "Shared/hooks/useTable.hook"

export const usePurchaseOrdersTable = <T extends { key: string }>(props: UseTablePropsBase<T>) =>
    useTable({
        ...props,
        localStorageKeyVisibleColumns: PURCHASE_ORDERS_TABLE_VISIBLE_COLUMNS,
        localStorageKeyColumnOrder: PURCHASE_ORDERS_TABLE_COLUMN_ORDER,
        columnToKeepAtEnd: PurchaseOrderColumns.ACTION,
    })
